import { render, staticRenderFns } from "./PersonTask.vue?vue&type=template&id=2d5bd09f&scoped=true&"
import script from "./PersonTask.vue?vue&type=script&lang=js&"
export * from "./PersonTask.vue?vue&type=script&lang=js&"
import style0 from "./PersonTask.vue?vue&type=style&index=0&id=2d5bd09f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5bd09f",
  null
  
)

export default component.exports